"use client";

import { ClientRouteErrorFallback } from "@shared/components/client-route-error-fallback";

interface PricingRouteErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

/**
 * Pricing segment error UI — hard reload (via shared fallback) so client
 * ReferenceErrors cannot soft-reset into the same broken module graph.
 */
export default function PricingRouteError({
	error,
	reset,
}: PricingRouteErrorProps) {
	return <ClientRouteErrorFallback error={error} reset={reset} />;
}
